import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { firebaseStorage } from "../components/sync";
import { decompressData } from "../components/foo";

export const downloadDemoTemplateA = async () => {

    const storageRef = ref(firebaseStorage, 'shared/activity/templateA/demo/AT1X_4.pecs');
  
    // Download the object from Firebase Storage
    const url = await getDownloadURL(storageRef);
  
    // Fetch the object
    const response = await fetch(url);
    const objectData = await response.arrayBuffer();
  
    // Convert ArrayBuffer to Uint8Array
    const uint8Data = new Uint8Array(objectData);
    // Decompress the data
    let pecs = decompressData(uint8Data);

  
    // Compress the images before importing
    //const entries = await Promise.all(Object.entries(pecs.l2Image).map(async ([k, v]) => [k, await compressImageBeforeImport(v as string)]));
    //pecs.l2Image = Object.fromEntries(entries);
    //console.log(pecs)
    return pecs;
  };


  export const downloadFullTemplateA = async () => {

    const storageRef = ref(firebaseStorage, 'shared/activity/templateA/full/templateA_19_activity.pecs');
  
    // Download the object from Firebase Storage
    const url = await getDownloadURL(storageRef);
  
    // Fetch the object
    const response = await fetch(url);
    const objectData = await response.arrayBuffer();
  
    // Convert ArrayBuffer to Uint8Array
    const uint8Data = new Uint8Array(objectData);
    // Decompress the data
    let pecs = decompressData(uint8Data);

  
    // Compress the images before importing
    //const entries = await Promise.all(Object.entries(pecs.l2Image).map(async ([k, v]) => [k, await compressImageBeforeImport(v as string)]));
    //pecs.l2Image = Object.fromEntries(entries);
    //console.log(pecs)
    return pecs;
  };